const airImportChargesData = {
    initialLength: 16,
    preList: [{
            id: 1,
            chargeDescription: 'Pick-up Charges',
            currency: '',
            minimum: 0,
            perKg: 0,
            perAWB: 0,
            onaccount: "On Your Account",
        },
        {
            id: 2,
            chargeDescription: 'Origin Customs Clearance',
            currency: '',
            minimum: 0,
            perKg: 0,
            perAWB: 0,
            disabled: ['perKg', 'minimum'],
            onaccount: "On Your Account",
        },
        {
            id: 3,
            chargeDescription: 'Airport Terminal Charges',
            currency: '',
            minimum: 0,
            perKg: 0,
            perAWB: 0,
            disabled: ['perAWB'],
            onaccount: "On Your Account",
        },
        {
            id: 4,
            chargeDescription: 'AWB Charges',
            currency: '',
            minimum: 0,
            perKg: 0,
            perAWB: 0,
            disabled: ['perKg', 'minimum'],
            onaccount: "On Your Account",
        },
        {
            id: 5,
            chargeDescription: 'AMS',
            currency: '',
            minimum: 0,
            perKg: 0,
            perAWB: 0,
            disabled: ['perKg', 'minimum'],
            onaccount: "On Your Account",
        },
        {
            id: 6,
            chargeDescription: 'Air Freight',
            currency: '',
            minimum: 0,
            perKg: 0,
            perAWB: 0,
            disabled: ['perAWB'],
            onaccount: "On Your Account",
        },
        {
            id: 7,
            chargeDescription: 'Fuel Surcharge',
            currency: '',
            minimum: 0,
            perKg: 0,
            perAWB: 0,
            disabled: ['perAWB'],
            onaccount: "On Your Account",
        },
        {
            id: 8,
            chargeDescription: 'Security Surcharge',
            currency: '',
            minimum: 0,
            perKg: 0,
            perAWB: 0,
            disabled: ['perAWB'],
            onaccount: "On Your Account",
        },
        {
            id: 9,
            chargeDescription: 'X-Ray/Screening Charges',
            currency: '',
            minimum: 0,
            perKg: 0,
            perAWB: 0,
            disabled: ['perAWB'],
            onaccount: "On Your Account",
        },
        {
            id: 10,
            chargeDescription: 'Landing Charges',
            currency: 'INR',
            minimum: 0,
            perKg: 0,
            perAWB: 0,
            disabled: ['perAWB'],
            onaccount: "On Your Account",
        },
        {
            id: 11,
            chargeDescription: 'Hazardous Surcharges',
            currency: '',
            minimum: 0,
            perKg: 0,
            perAWB: 0,
            disabled: ['perKg', 'minimum'],
            onaccount: "On Your Account",
        },
        {
            id: 12,
            chargeDescription: 'Delivery Order Charges',
            currency: 'INR',
            minimum: 0,
            perKg: 0,
            perAWB: 0,
            disabled: ['perKg', 'minimum'],
            onaccount: "On Your Account",
        },
        {
            id: 13,
            chargeDescription: 'Destination Terminal Handling Charges',
            currency: 'INR',
            minimum: 0,
            perKg: 0,
            perAWB: 0,
            disabled: ['perAWB'],
            onaccount: "On Your Account",
        },
        {
            id: 14,
            chargeDescription: 'Destination Customs Clearance',
            currency: 'INR',
            minimum: 0,
            perKg: 0,
            perAWB: 0,
            disabled: ['perKg', 'minimum'],
            onaccount: "On Your Account",
        },
        {
            id: 15,
            chargeDescription: 'Door Delivery Charges',
            currency: 'INR',
            minimum: 0,
            perKg: 0,
            perAWB: 0,
            onaccount: "On Your Account",
        },
        {
            id: 16,
            chargeDescription: 'Charges Collect Fee(CC Fees)',
            currency: 'INR',
            minimum: 0,
            perKg: 0,
            perAWB: 0,
            disabled: ['perKg', 'minimum'],
            onaccount: "On Your Account",
        }
    ]
}
export default airImportChargesData